import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "../style.scss";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Scheduler from "./Scheduler";
import { addAppointmentRequest, editAppointmentRequest, getAppointmentsByUsersRequest } from "../../../store/appointments/actions";


const AddAppointmentForm = ({ intl: { messages }, show, close, patientId, selectedApp }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [availableTimes, setAvailableTimes] = useState([]);
     const [selectedAppsDate, setSelectedAppsDate] = useState(moment().format('YYYY-MM-DD'));
     const [selectedTime, setSelectedTime] = useState(moment().format('HH:mm'));
     const { appointmentsByUsers, addedApp } = useSelector((state) => state.appointments);
     const [specialistList, setSpecialistList] = useState([]);
     const [selectedUserId, setSelectedUserId] = useState(0);
     const appTypes = [
        {id: 2, name: messages.patients.form.video_call},
        {id: 4, name: messages.patients.form.at_office},
        {id: 3, name: messages.patients.form.audio_call},
        {id: 1, name: messages.patients.form.textual_app},
    ]
     const appStatus = [
        {id: 1, name: messages.patients.form.first_app},
        {id: 2, name: messages.patients.form.inquiry_app},
        {id: 3, name: messages.patients.form.explantation_app},
    ]
     const [appointment, setAppointment] = useState({
        patient_id: patientId,
        user_id: 0,
        start_date: '',
        type: 0,
        purpose: 1,
        time: '',
    });

    const clear = () => {
        setAppointment({
            patient_id: patientId,
            user_id: 0,
            start_date: '',
            type: 0,
            purpose: 1,
            time: '',
        });
        setSelectedUserId(0);
        setSelectedAppsDate(moment().format('YYYY-MM-DD'));
        setSelectedTime(null);
    }

    const validation = () => {
        let isValid = true;
        if (appointment?.purpose === 0 ) {
            document.getElementById('appStatus').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.app_status_feedback);
        }
        if (appointment?.type === 0) {
            document.getElementById('appTypes').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.app_type_feedback);
        }
        if (!appointment?.time) {
            isValid = false;
            setFeedBack(messages.patients.form.time_feedback);
        }
        if (appointment?.user_id === 0) {
            document.getElementById('specialist').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.specialist_feedback);
        }
        return isValid;
    }

     useEffect(() => {
         if (selectedAppsDate) {
            setSelectedUserId(0);
            dispatch(getAppointmentsByUsersRequest({ date: selectedAppsDate }));
        }
    }, [dispatch, selectedAppsDate]);

    // if Selected App
    useEffect(() => {
        if (selectedApp) {
            // console.log(selectedApp);
            setSelectedAppsDate(moment(selectedApp.start_date).format('YYYY-MM-DD'));
            setSelectedUserId(selectedApp.user_id);
            setAppointment({
                ...appointment,
                id: selectedApp.id,
                user_id: selectedApp.user_id,
                start_date: moment(selectedApp.start_date).format('YYYY-MM-DD'),
                type: selectedApp.type,
                purpose: selectedApp.purpose,
                time: selectedApp.start_date.split(' ')[1],
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedApp]);

    // Users List
    useEffect(() => {
        if (appointmentsByUsers && appointmentsByUsers.length > 0) {
            let list = [];
            appointmentsByUsers.forEach((item) => {
                list.push({
                    id: item.id,
                    name: item.name,
                });
            });
            setSpecialistList(list);
        } else {
            setSpecialistList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentsByUsers])

    useEffect(() => {
        if (parseInt(selectedUserId) > 0) {
            let appTimes = [];
            appointmentsByUsers.forEach(app => {
                if (parseInt(app.id) === parseInt(selectedUserId)) {
                    app.available_appointments?.forEach((time, index) => {
                        appTimes.push({
                            id: index,
                            value: time,
                            text: moment(time, 'HH:mm:ss').format('hh:mm A')
                        });
                    })
                }
            })
            setAvailableTimes(appTimes);
        } else {
            setAvailableTimes([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUserId])

    //Clear and close
    useEffect(() => {
        if (addedApp) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedApp]);

    return (
        <div className={`add-app_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="add-app_container_content">
                    <CancelIcon onClick={close} className="add-app_container_content_close" />
                <div className="add-app_container_content_header">
                    <h4>{selectedApp ? messages.patients.appointments.edit : messages.patients.appointments.btn}</h4>
                </div>
                <div className="add-app_container_content_body">
                    <form>
                        <div className="row">
                            <div className="col-md-8">
                                <Scheduler userId={selectedUserId} currentDate={selectedAppsDate} />
                            </div>
                            <div className="col-md-4">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} local={lang === 'ar' ? 'ar-SA' : 'en-US'}>
                                    <DatePicker
                                        autoOk
                                        disableToolbar={true}
                                        orientation="landscape"
                                        variant="static"
                                        openTo="date"
                                        value={selectedAppsDate}
                                        onChange={(date) => setSelectedAppsDate(moment(date).format('YYYY-MM-DD'))}
                                    />
                                </MuiPickersUtilsProvider>
                                <div style={{ marginTop: '20px' }}>
                                    <label htmlFor="specialist" >{messages.patients.form.specialist}</label>
                                    <select name="specialist" id="specialist"
                                            style={{ width: '100%' }}
                                            value={selectedUserId}
                                            onChange={e => {
                                                document.getElementById('specialist').style.borderColor = '#eee';
                                                setFeedBack('');
                                                setSelectedUserId(e.target.value);
                                                setAppointment({ ...appointment, user_id: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.specialist_placeholder}</option>
                                        {specialistList?.map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                                    </select>
                                </div>
                                <div className="timepicker-container">
                                    {availableTimes?.map(time => 
                                        <div key={time.id} className={`timepicker-item ${selectedTime === time.id && 'active'}`} onClick={() => {
                                            setAppointment({ ...appointment, time: time.value })
                                            setSelectedTime(time.id)
                                        }}>
                                            {time.text}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <label htmlFor="appTypes" >{messages.patients.form.app_type}</label>
                                    <select name="appTypes" id="appTypes"
                                            style={{ width: '100%' }}
                                            value={appointment.type}
                                            onChange={e => {
                                                document.getElementById('appTypes').style.borderColor = '#eee';
                                                setFeedBack('');
                                                setAppointment({ ...appointment, type: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_type_placeholder}</option>
                                        {appTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="appStatus" >{messages.patients.form.app_status}</label>
                                    <select name="appStatus" id="appStatus"
                                            style={{ width: '100%' }}
                                            value={appointment.purpose}
                                            onChange={e => {
                                                document.getElementById('appStatus').style.borderColor = '#eee';
                                                setFeedBack('');
                                                    setAppointment({ ...appointment, purpose: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_status_placeholder}</option>
                                        {appStatus?.map(status => <option key={status.id} value={status.id} 
                                                               // disabled={(status.id === 1 && appointment.purpose === 2) || (status.id === 1 && appointment.purpose === 3) || (appointment.purpose === 1 && status.id !== 1)}
                                                                >{status.name}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button onClick={(e) =>  {
                                    e.preventDefault();
                                    if (selectedApp) {
                                        dispatch(editAppointmentRequest({ ...appointment, start_date: `${selectedAppsDate} ${appointment.time}` }));
                                    } else if (validation()) {
                                        dispatch(addAppointmentRequest({ ...appointment, start_date: `${selectedAppsDate} ${appointment.time}` }));
                                    }
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(AddAppointmentForm);
